import { render, staticRenderFns } from "./adminDetail.vue?vue&type=template&id=60972121&scoped=true"
import script from "./adminDetail.vue?vue&type=script&lang=js"
export * from "./adminDetail.vue?vue&type=script&lang=js"
import style0 from "./adminDetail.vue?vue&type=style&index=0&id=60972121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60972121",
  null
  
)

export default component.exports